import classes from "./Container.module.scss";
const Container = props => <div className={classes.main}>{props.children}</div>
export default Container
